import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import {
  Autocomplete,
  Button,
  Divider,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';

import { IAccount } from 'common/src/types/interfaces';

import GenericDialog from 'portal/src/components/common/GenericDialog';
import LightTooltip from 'portal/src/components/common/LightTooltip';

const AddSubAccountDetailsDialog = ({
  availableSubAccounts,
  generateDisabled,
  isMissingMasterMeters,
  onAddExisting,
  onCancel,
  onGenerateNew,
  open,
}: {
  availableSubAccounts: IAccount[];
  generateDisabled: boolean;
  isMissingMasterMeters: boolean;
  onAddExisting: (account: IAccount) => void;
  onCancel: () => void;
  onGenerateNew: () => void;
  open: boolean;
}) => {
  const handleClose = () => {
    onCancel();
  };

  return (
    <GenericDialog
      maxWidth="xs"
      open={open}
      onClose={handleClose}
      title="Add Sub Account Details"
    >
      <Stack sx={{ maxWidth: 440 }}>
        <Stack my={2}>
          <Autocomplete
            getOptionLabel={(a) => a.number}
            options={availableSubAccounts}
            onChange={(_, val) => {
              if (!val) {
                return;
              }
              onAddExisting(val);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                label="Add Existing Sub Account"
              />
            )}
            size="small"
            sx={{ width: '100%' }}
          />
        </Stack>

        <Divider>or</Divider>

        <Stack my={2} alignItems="center">
          <LightTooltip title="Creates a new sub account and sub meters under this master account">
            <span>
              <Button
                color="secondary"
                disabled={generateDisabled}
                disableElevation
                onClick={onGenerateNew}
                startIcon={<AutoFixHighIcon />}
                variant="outlined"
              >
                Generate New Sub Account
              </Button>
            </span>
          </LightTooltip>
          {isMissingMasterMeters && (
            <Typography
              color="error"
              mt={2}
              textAlign="center"
              variant="caption"
            >
              No master meters are associated with this account. You must attach
              a master meter to it in order to generate a sub account.
            </Typography>
          )}
        </Stack>

        <Stack direction="row" justifyContent="flex-end" mt={2}>
          <Button color="info" onClick={handleClose} variant="outlined">
            Cancel
          </Button>
        </Stack>
      </Stack>
    </GenericDialog>
  );
};

export default AddSubAccountDetailsDialog;
